import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where, addDoc } from "firebase/firestore";
import { db } from "../../../firebase/Firebase"; // Firestore instance
import Header from "../../common/header/Header";
import Kundli_Main_Banner from "../kundli/kundli_main_bannner/Kundli_Main_Banner";
import Home_Private_Confidential from "../home_page_components/home_private_confidential/Home_Private_Confidential";
import Footer from "../../common/footer/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { User_Authentication } from "../../../user_authentication/User_Authentication";
import {
  Add_follow_Astro,
  Get_Astrologer_Details,
  Get_Web_Astrologer_Details,
} from "../../../api/astrologer/Astrologer";
import Loader from "../../../loader/Loader";
import {
  AGORA_APP_CHAT_APP_KEY,
  AGORA_APP_ID,
  IMG_BASE_URL,
  WEB_DOMAIN_KEY,
} from "../../../config/Config";
import Common_Images_Transport from "../../common/common_imges_transport/Common_Images_Transport";
import Astrologer_Gallery_Profile from "./astrologer_list/Astrologer_Gallery_Profile";
import { toast } from "react-toastify";

import { Agora_Generate_Token, Chat_Token } from "../../../api/agora/Agora";
import AgoraRTC from "agora-rtc-sdk-ng";
// import WebIM from "agora-chat";
import AC from "agora-chat";
import axios from "axios";
import { Helmet } from "react-helmet";
import facebookIcon from "../../../assets/images/logosocial/facebook-svgrepo-com.svg";
import instagramIcon from "../../../assets/images/logosocial/instagram-svgrepo-com.svg";
import linkedinIcon from "../../../assets/images/logosocial/linkedin-svgrepo-com.svg";
import youtubeIcon from "../../../assets/images/logosocial/youtube-color-svgrepo-com.svg";
import websiteIcon from "../../../assets/images/logosocial/globe-1-svgrepo-com.svg";

const Astrologer_Details = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [is_Chat_loading, setIs_Chat_Loading] = useState(false);
  const [astro_details_list, set_Astro_Details_List] = useState({});
  const [is_chat_assistant, set_Is_Chat_Assistant] = useState(false);
  const [is_image_modal_open, set_Is_Image_Modal_Open] = useState(false);
  const [is_loading, set_Is_Loading] = useState(false);
  const Get_user_is_active = localStorage.getItem("user_is_active");

  const handle_chat_click = () => {
    navigate("/download-app");
  };

  //    <--------- get the astologer details pages ------------->
  // const Handle_Get_Astrologer_details = async () => {
  //     set_Is_Loading(true);
  //     try {
  //         if (Get_user_is_active) {
  //             const token = User_Authentication();
  //             if (!token) {
  //                 set_Is_Loading(false);
  //                 throw new Error("User token not found");
  //             }
  //             const response = await Get_Astrologer_Details(
  //                 "1", id,
  //                 { Authorization: `Bearer ${token}` }
  //             );
  //             console.log("astro_details_111111", response);
  //             set_Astro_Details_List(response?.data?.data)
  //             localStorage.setItem("astrologer_profile_image", response?.data?.data?.astrolist?.profile_image)
  //             localStorage.setItem("astrologer_name", response?.data?.data?.astrolist?.name)
  //         } else {
  //             const response = await Get_Web_Astrologer_Details("1", id,);
  //             console.log("products_products_222222", response);
  //             set_Astro_Details_List(response?.data?.data)
  //         }
  //     } catch (error) {
  //         console.error(error);
  //     } finally {
  //         set_Is_Loading(false);
  //     }
  // };
  const Handle_Get_Astrologer_details = async () => {
    set_Is_Loading(true);
    try {
      const token = User_Authentication(); // token

      if (token) {
        //   Authenticated call
        const response = await Get_Astrologer_Details("1", username, {
          Authorization: `Bearer ${token}`,
        });

        if (response?.data?.status == 200) {
          set_Astro_Details_List(response?.data?.data);
          localStorage.setItem(
            "astrologer_profile_image",
            response?.data?.data?.astrolist?.profile_image || "",
          );
          localStorage.setItem(
            "astrologer_name",
            response?.data?.data?.astrolist?.name || "",
          );
        }

        if (response?.response?.data?.status == 500) {
          toast.error(response?.response?.data?.message);
          navigate("/");
          return;
        }
      } else {
        //   Public call
        const response = await Get_Web_Astrologer_Details("1", username);
        if (response?.data?.status == 200) {
          set_Astro_Details_List(response?.data?.data);
        }
        if (response?.response?.data?.status == 500) {
          toast.error(response?.response?.data?.message);
          navigate("/");
          return;
        }
      }
    } catch (error) {
      console.error("Error fetching astrologer details:", error);
    } finally {
      set_Is_Loading(false);
    }
  };

  // <---------- add the astrologer in the follow list -------->
  const Handle_Add_follow_Astro = async (id) => {
    set_Is_Loading(true);
    const data = {
      astro_id: id,
    };
    try {
      const token = User_Authentication();
      if (!token) {
        set_Is_Loading(false);
        toast("user not login here ");
        throw new Error("User token not found");
      }
      const response = await Add_follow_Astro(data, {
        Authorization: `Bearer ${token}`,
      });
      if (response?.data?.status == "200") {
        set_Is_Loading(false);
        toast(response?.data?.message);
        Handle_Get_Astrologer_details("1", id, {
          Authorization: `Bearer ${token}`,
        });
      } else if (response?.response?.data?.status == "500") {
        set_Is_Loading(false);
        toast(response?.response?.data?.message);
      }
    } catch (error) {
      set_Is_Loading(false);
    }
  };

  useEffect(() => {
    Handle_Get_Astrologer_details();
  }, []);

  // Scroll to the top of the page when the component is rendered
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function for date formatter
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const time = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month}, ${year} AT ${time}`;
  };

  const aboutUs = astro_details_list?.astrolist?.astrodetail?.about_us;
  const shortAbout =
    aboutUs?.length > 150 ? aboutUs?.substring(0, 150) + "..." : aboutUs;
  const skills = astro_details_list?.astrolist?.skills?.replace(/,/g, ", ");

  return (
    <>
      <Helmet>
        <title>
          {(() => {
            const name = astro_details_list?.astrolist?.name || "";
            const role =
              astro_details_list?.astrolist?.user_role == 2
                ? "astrologer"
                : "Pandit";
            const rawSkills = astro_details_list?.astrolist?.skills || "";
            const cleanName = name.replace(/^["']|["']$/g, "");
            const cleanSkills = rawSkills
              .replace(/^["']|["']$/g, "")
              .replace(/,/g, ", ");
            const title = `${cleanName} ${role} - ${cleanSkills} Expert`;
            return title.replace(/^["']|["']$/g, "");
          })()}
        </title>
        <meta name="description" content={shortAbout} />
        <link
          rel="canonical"
          href={`${WEB_DOMAIN_KEY}${astro_details_list?.astrolist?.user_role === 2 ? "astrologer" : "pandit"}/${astro_details_list?.astrolist?.user_name}`}
        />

        <link
          rel="alternate"
          hreflang="en-us"
          href={`${WEB_DOMAIN_KEY}${astro_details_list?.astrolist?.user_role === 2 ? "astrologer" : "pandit"}/${astro_details_list?.astrolist?.user_name}`}
        />
      </Helmet>
      <div>
        {/* <------ Header section's ---------> */}
        <Header />
        {/*  */}
        {/* <Kundli_Main_Banner /> */}
        {/* <-------- ToastContainer ------------> */}
        {is_loading ? (
          <Loader />
        ) : (
          <section className="gi-category py-[40px] max-[767px]:p-[15px] bg-gray-50">
            <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1170px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
              <div className="w-full">
                <div className="gi-shop-rightside w-full px-[12px]">
                  {/* <!-- Shop content Start --> */}
                  <div className="shop-pro-content">
                    <div className="w-full mb-6 grid_call_chat">
                      <div className="gi-product-content  overflow-hidden rounded-[5px] shadow-xl p-6 bg-white">
                        <div className="gi-product-inner md:flex lg:flex gap-3 transition-all duration-[0.3s] ease-in-out ">
                          <div className="flex flex-col gap-9">
                            <div className="gi-pro-image w-[200px] text-center">
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  set_Is_Image_Modal_Open(true);
                                }}
                                className="relative cursor-pointer"
                              >
                                {astro_details_list?.astrolist?.profile_image !=
                                  null ? (
                                  <img
                                    className="main-image rounded-lg m-auto  w-[180px] h-[180px] transition-all duration-[0.3s] ease delay-[0s]"
                                    src={`${IMG_BASE_URL}${astro_details_list?.astrolist?.profile_image}`}
                                    alt={`${astro_details_list?.astrolist?.name}`}
                                  />
                                ) : (
                                  <img
                                    className="main-image rounded-lg m-auto  w-[180px] h-[180px] transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.user_logo}
                                    alt={`${astro_details_list?.astrolist?.name}`}
                                  />
                                )}
                              </a>
                            </div>
                            <div className="gap-4 items-center grid grid-cols-3">
                              {/*   
  {astro_details_list?.astrolist?.astrodetail?.facebook && (
    <a
      href={astro_details_list.astrolist.astrodetail.facebook}
      target="_blank"
      rel="noopener noreferrer"
      className="text-center rounded-lg flex justify-center w-full p-1 border border-gray-200 gap-2 text-[13px] items-center"
    >
      <img src={facebookIcon} className="h-7" alt="facebook" />
    </a>
  )}

  {astro_details_list?.astrolist?.astrodetail?.instagram && (
    <a
      href={astro_details_list.astrolist.astrodetail.instagram}
      target="_blank"
      rel="noopener noreferrer"
      className="text-center rounded-lg flex justify-center w-full p-1 border border-gray-200 gap-2 text-[13px] items-center"
    >
      <img src={instagramIcon} className="h-7" alt="instagram" />
    </a>
  )}

  {astro_details_list?.astrolist?.astrodetail?.linked_in && (
    <a
      href={astro_details_list.astrolist.astrodetail.linked_in}
      target="_blank"
      rel="noopener noreferrer"
      className="text-center rounded-lg flex justify-center w-full p-1 border border-gray-200 gap-2 text-[13px] items-center"
    >
      <img src={linkedinIcon} className="h-7" alt="linkedin" />
    </a>
  )}

  {astro_details_list?.astrolist?.astrodetail?.youtube && (
    <a
      href={astro_details_list.astrolist.astrodetail.youtube}
      target="_blank"
      rel="noopener noreferrer"
      className="text-center rounded-lg flex justify-center w-full p-1 border border-gray-200 gap-2 text-[13px] items-center"
    >
      <img src={youtubeIcon} className="h-7" alt="youtube" />
    </a>
  )}

  {astro_details_list?.astrolist?.astrodetail?.website && (
    <a
      href={astro_details_list.astrolist.astrodetail.website}
      target="_blank"
      rel="noopener noreferrer"
      className="text-center rounded-lg flex justify-center w-full p-1 border border-gray-200 gap-2 text-[13px] items-center"
    >
      <img src={websiteIcon} className="h-7" alt="website" />
    </a>
  )} */}



                            </div>
                          </div>
                          <div className="gi-pro-content grid lg:grid-cols-3 gap-3 w-full h-full p-3 pt-0 pb-5 relative z-[10]">
                            <div className="col-span-2 pt-2">
                              <h1 className="text-gray-900 text-xl font-semibold capitalize">
                                {astro_details_list?.astrolist?.name}
                              </h1>

                              <div className="text-gray-800 mt-2 font-semibold text-md">
                                Rs.
                                {
                                  astro_details_list?.astrolist?.astro_amounts
                                    ?.audio_call_rate
                                }
                                /min
                              </div>
                              <div className="gi-pro-rat-price pt-2 gap-2 items-center flex">
                                <span className="gi-pro-rating opacity-[0.7] relative">
                                  {[...Array(5)].map((_, i) => {
                                    const full = Math.floor(
                                      astro_details_list?.average_rating,
                                    );
                                    const isHalf =
                                      astro_details_list?.average_rating -
                                      full >=
                                      0.5 && i === full;

                                    return (
                                      <span
                                        key={i}
                                        className="relative inline-block text-[14px] mr-[3px] w-[13px] h-[13px]"
                                      >
                                        <i className="gicon gi-star text-gray-300 absolute top-0 left-0 w-full h-full" />
                                        {i < full && (
                                          <i className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full" />
                                        )}
                                        {isHalf && (
                                          <i
                                            className="gicon gi-star text-yellow-400 absolute top-0 left-0 w-full h-full overflow-hidden"
                                            style={{ width: "50%" }}
                                          />
                                        )}
                                      </span>
                                    );
                                  })}
                                </span>
                                <span className="font-semibold text-[14px] text-white bg-red-400 px-3 rounded-full">
                                  {astro_details_list?.average_rating > 0
                                    ? astro_details_list?.average_rating.toFixed(
                                      1,
                                    )
                                    : "0.0"}
                                </span>
                              </div>

                              <div className="mt-2">
                                <div className="text-gray-600 font-medium mt-1 mr-4 text-[14px]">
                                  Skills:{" "}
                                  <span className="text-gray-900 font-semibold">
                                    {astro_details_list?.astrolist?.skills?.replace(
                                      /,/g,
                                      ", ",
                                    )}
                                  </span>
                                </div>
                                <div className="text-gray-600 font-medium mt-1 mr-4 text-[14px]">
                                  language:{" "}
                                  <span className="text-gray-900 font-semibold">
                                    {astro_details_list?.astrolist?.language?.replace(
                                      /,/g,
                                      ", ",
                                    )}
                                  </span>
                                </div>
                                <div className="text-gray-600 font-medium mt-1 text-[14px]">
                                  Exp.:{" "}
                                  <span className="text-gray-900 font-semibold">
                                    {astro_details_list?.astrolist?.experience}{" "}
                                    Yrs
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="mt-6 justify-between items-center w-full">

                              <div className="gap-4 flex items-center ml-4">
                                <Link
                                  to="/download-app"
                                  className="text-center rounded-lg flex justify-center w-full p-1 px-4 hover:text-red-800 border border-gray-200 text-[13px] items-center font-semibold gap-2"
                                >
                                  <img
                                    src={Common_Images_Transport?.call_icon}
                                    className="h-7"
                                    alt=""
                                  />
                                  Call
                                </Link>

                                <Link
                                  to="/download-app"
                                  className="text-center rounded-lg flex justify-center w-full p-1 px-4 hover:text-red-800 border border-gray-200 text-[13px] items-center font-semibold gap-2"
                                >
                                  <img
                                    src={Common_Images_Transport?.chat_icon}
                                    className="h-7"
                                    alt=""
                                  />
                                  Chat
                                </Link>
                                <div
                                  onClick={() =>
                                    Handle_Add_follow_Astro(
                                      astro_details_list?.astrolist?.id,
                                    )
                                  }
                                >
                                  {astro_details_list?.astrolist
                                    ?.is_favourite == true ? (
                                    <Link className=" text-white bg-[#FFB800] focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-[13px] px-5 py-2.5 text-center  dark:hover:text-white dark:hover:bg-[#9F2225] dark:focus:ring-red-900">
                                      UnFollow
                                    </Link>
                                  ) : (
                                    <Link className=" text-white bg-green-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-[13px] px-5 py-2.5 text-center  dark:hover:text-white dark:hover:bg-[#9F2225] dark:focus:ring-red-900">
                                      Follow
                                    </Link>
                                  )}
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="aboutinfo border-t border-[#eee] mt-4 pt-4">
                          <h2 className="text-lg text-gray-900 font-semibold">
                            About {astro_details_list?.astrolist?.name}
                          </h2>
                          <p className="text-gray-700 leading-[1.8]">
                            {
                              astro_details_list?.astrolist?.astrodetail
                                ?.about_us
                            }
                          </p>
                        </div>
                        <Astrologer_Gallery_Profile data={astro_details_list} />
                      </div>
                    </div>
                  </div>
                  {/* <!--Shop content End --> */}
                </div>
                {/* <!-- Sidebar Area Start --> */}
                <div className="gi-shop-sidebar">
                  <div id="shop_sidebar">
                    <div className="bg-[#FFF9F1] shadow">
                      <div className="p-5">
                        <div className="flex gap-5 pt-3 items-center">
                          <div className="bg-white rounded-full p-4">
                            <i className="gicon gi-star text-[25px] text-[#FFB800] float-left"></i>
                          </div>
                          <div>
                            <h2 className="text-lg font-semibold text-gray-900">
                              Rating & Reviews
                            </h2>
                            <span className="text-gray-700 font-medium text-xs">
                              852 Trustpilot Review
                            </span>
                          </div>
                        </div>
                        <a
                          href="#"
                          data-modal-id="modal2"
                          onClick={() => set_Is_Chat_Assistant(true)}
                          className="modal-link border border-gray-300 text-gray-800 text-center p-2 text-sm w-[100%] left inline-block mt-3 font-medium rounded"
                        >
                          Chat with Assistant?
                        </a>

                        {/*  */}
                        {is_chat_assistant && (
                          <div id="modal2" class="custom-modal">
                            <div class="custom-modal-dialog">
                              <div class="custom-modal-content">
                                <span
                                  class="close-modal"
                                  onClick={() => set_Is_Chat_Assistant(false)}
                                >
                                  X
                                </span>
                                <div class="custom-modal-body">
                                  <div class="custom-modal-inner">
                                    {/* <!-- Content here --> */}
                                    <p class="text-gray-700">
                                      You can chat with astrologer’s assistant
                                      only when you have taken a paid session
                                      with the astrologer.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="bg-white h-full overflow-y-auto">
                        {astro_details_list?.astro_reviews?.length > 0 ? (
                          astro_details_list.astro_reviews.map(
                            (review_result) => (
                              <div className="gi-t-review-item p-5 border-b-[1px] border-solid border-[#eee]">
                                <div className="gi-t-review-content">
                                  <div className="gi-t-review-top flex items-center mb-[10px]">
                                    <div className="gi-t-review-avtars basis-[70px] grow-[0] shrink-[0] mr-[10px]">
                                      <img
                                        src={`${IMG_BASE_URL}${review_result?.users?.profile_image
                                          }`}
                                        alt="user"
                                        className="max-w-full rounded-full w-16 h-16"
                                      />
                                    </div>
                                    <div className="w-full">
                                      <h4 className="gi-t-review-name font-medium text-[18px] m-[0] leading-[1.5] block text-[#000]">
                                        {review_result?.users?.name}
                                      </h4>
                                      <div className="flex justify-between items-center">
                                        <div className="gi-t-review-rating mt-2">
                                          {[...Array(5)].map((_, i) => (
                                            <i
                                              key={i}
                                              className={`gicon gi-star inline-block float-left text-[14px] mr-[3px] ${i < review_result.rating
                                                  ? "text-[#f27d0c]"
                                                  : "text-[#ccc]"
                                                }`}
                                            ></i>
                                          ))}
                                        </div>
                                        <div className="text-sm text-gray-500">
                                          {formatDate(
                                            review_result?.created_at,
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="gi-t-review-bottom">
                                    <p className="w-full text-[14px] text-[#777] font-normal line-clamp-5 mt-3">
                                      {review_result?.review}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ),
                          )
                        ) : (
                          <p class="text-gray-500 text-center">
                            No reviews yet.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {/*<------- Home_Private_Confidential -------->  */}
        <Home_Private_Confidential />
        {/* <---------- Footer ----------> */}
        <Footer />
      </div>

      {/* Image Preview Modal */}
      {is_image_modal_open && (
        <div
          className="fixed inset-0 z-[9999] flex justify-center items-center bg-black bg-opacity-80 transition-opacity"
          onClick={() => set_Is_Image_Modal_Open(false)}
        >
          <div
            className="relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute -top-10 right-0 text-white hover:text-gray-300 text-3xl font-bold pick-none focus:outline-none"
              onClick={() => set_Is_Image_Modal_Open(false)}
            >
              &times;
            </button>
            <div className="bg-white p-2 rounded-lg shadow-2xl">
              <img
                src={astro_details_list?.astrolist?.profile_image != null ? `${IMG_BASE_URL}${astro_details_list?.astrolist?.profile_image}` : Common_Images_Transport?.user_logo}
                alt={`${astro_details_list?.astrolist?.name}`}
                className="max-w-[90vw] max-h-[85vh] object-contain rounded"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Astrologer_Details;
